/* Vantley cart drawer + mobile menu.
   Talks to the real Shopify cart (/cart/change.js, /cart.js) and re-renders the
   drawer from a section render, so line items, discounts and totals stay truthful. */
(function () {
  'use strict';
  if (window.__vantleyChromeBooted) return;
  window.__vantleyChromeBooted = true;

  var DRAWER = '[data-vt-cart-drawer]';

  function q(sel, scope) { return (scope || document).querySelector(sel); }
  function qa(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function openDrawer() {
    var d = q(DRAWER); if (!d) return;
    d.classList.add('is-open'); document.body.classList.add('vt-noscroll');
    var x = q('[data-vt-cart-close]', d); if (x) x.focus();
  }
  function closeDrawer() {
    var d = q(DRAWER); if (!d) return;
    d.classList.remove('is-open'); document.body.classList.remove('vt-noscroll');
  }
  function openMenu() {
    var m = q('[data-vt-menu]'); if (!m) return;
    m.classList.add('is-open'); document.body.classList.add('vt-noscroll');
  }
  function closeMenu() {
    var m = q('[data-vt-menu]'); if (!m) return;
    m.classList.remove('is-open'); document.body.classList.remove('vt-noscroll');
  }

  /* Pull a fresh copy of the header section and swap the drawer + cart count in. */
  function refresh(reopen) {
    var host = q('[data-vt-header]');
    if (!host) return Promise.resolve();
    var id = host.dataset.vtSectionId;
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=' + id : '/?section_id=' + id)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshDrawer = doc.querySelector(DRAWER);
        var oldDrawer = q(DRAWER);
        if (freshDrawer && oldDrawer) {
          var wasOpen = oldDrawer.classList.contains('is-open') || reopen;
          oldDrawer.innerHTML = freshDrawer.innerHTML;
          if (wasOpen) oldDrawer.classList.add('is-open');
        }
        var freshCount = doc.querySelector('[data-vt-cart-count]');
        if (freshCount) qa('[data-vt-cart-count]').forEach(function (el) { el.textContent = freshCount.textContent; });
        primeFree();
      })
      .catch(function () {});
  }

  /* Shopify applies an automatic discount a beat after /cart/add.js returns, so a
     section render fired immediately can still show the pre-discount cart. Read
     /cart.js until the totals stop moving (or we run out of patience) first. */
  function settleCart(tries) {
    tries = tries == null ? 4 : tries;
    var last = null;
    var step = function (n) {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var sig = cart.item_count + ':' + cart.total_price + ':' + cart.total_discount;
          if (n <= 0 || sig === last) return cart;
          last = sig;
          return new Promise(function (res) { setTimeout(res, 220); }).then(function () { return step(n - 1); });
        })
        .catch(function () { return null; });
    };
    return step(tries);
  }

  function setBusy(on, lineEl) {
    var d = q(DRAWER);
    if (d) { if (on) d.setAttribute('aria-busy', 'true'); else d.removeAttribute('aria-busy'); }
    if (lineEl) lineEl.classList.toggle('is-busy', !!on);
  }

  function changeLine(key, qty, lineEl) {
    setBusy(true, lineEl);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return settleCart(); })
      .then(function () { return refresh(true); })
      .catch(function () {})
      .then(function () { setBusy(false); });
  }

  /* ───────────── FREE PAIR PICKER ───────────── */
  function freeState(picker) {
    var sel = function (s) { var e = picker.querySelector(s); return e; };
    return {
      color: (sel('[data-vt-free-color].is-selected') || {}).dataset ? sel('[data-vt-free-color].is-selected').dataset.vtFreeColor : null,
      gender: (function () { var t = sel('[data-vt-free-gender].is-active'); return t ? t.dataset.vtFreeGender : null; })(),
      size: (function () { var p = sel('[data-vt-free-size].is-selected'); return p ? p.dataset.vtFreeSize : null; })()
    };
  }

  function renderFree(picker) {
    var data = JSON.parse(picker.querySelector('[data-vt-free-json]').textContent);
    var st = freeState(picker);
    var nameEl = picker.querySelector('[data-vt-free-color-name]');
    if (nameEl && st.color) nameEl.textContent = st.color;

    qa('[data-vt-free-size]', picker).forEach(function (p) {
      if (p.dataset.vtSizeGender) p.hidden = p.dataset.vtSizeGender !== st.gender;
    });

    var btn = picker.querySelector('[data-vt-free-add]');
    var needsSize = data.sizeIndex >= 0;
    var ok = !needsSize || st.size !== null;
    btn.disabled = !ok;
    btn.textContent = ok ? btn.dataset.vtLabelAdd : btn.dataset.vtLabelNosize;
    return { data: data, st: st };
  }

  function freeVariantId(picker) {
    var r = renderFree(picker), data = r.data, st = r.st;
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (!v.available) continue;
      if (data.colorIndex >= 0 && st.color && v.options[data.colorIndex] !== st.color) continue;
      if (data.genderIndex >= 0 && st.gender && v.options[data.genderIndex] !== st.gender) continue;
      if (data.sizeIndex >= 0 && st.size && v.options[data.sizeIndex] !== st.size) continue;
      if (data.sizeIndex >= 0 && !st.size) continue;
      return v.id;
    }
    return null;
  }

  function addFreePair(picker) {
    var id = freeVariantId(picker);
    if (!id) return;
    setBusy(true);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return settleCart(); })
      .then(function () { return refresh(true); })
      .catch(function () {})
      .then(function () { setBusy(false); });
  }

  /* delegated — the drawer's contents are replaced on every change */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-vt-cart-open]')) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-vt-cart-close]')) { e.preventDefault(); closeDrawer(); return; }
    if (t.closest('[data-vt-menu-open]')) { e.preventDefault(); openMenu(); return; }
    if (t.closest('[data-vt-menu-close]')) { e.preventDefault(); closeMenu(); return; }

    var step = t.closest('[data-vt-line-qty]');
    if (step) {
      e.preventDefault();
      changeLine(step.dataset.vtLineKey, parseInt(step.dataset.vtLineQty, 10), step.closest('.vh-line'));
      return;
    }
    var rm = t.closest('[data-vt-line-remove]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.vtLineKey, 0, rm.closest('.vh-line')); return; }

    /* free pair picker */
    var picker = t.closest('[data-vt-free-picker]');
    if (!picker) return;

    var tile = t.closest('[data-vt-free-color]');
    if (tile) {
      e.preventDefault();
      qa('[data-vt-free-color]', picker).forEach(function (x) { x.classList.toggle('is-selected', x === tile); });
      renderFree(picker);
      return;
    }
    var gtab = t.closest('[data-vt-free-gender]');
    if (gtab) {
      e.preventDefault();
      qa('[data-vt-free-gender]', picker).forEach(function (x) { x.classList.toggle('is-active', x === gtab); });
      qa('[data-vt-free-size]', picker).forEach(function (x) { x.classList.remove('is-selected'); });
      renderFree(picker);
      return;
    }
    var pill = t.closest('[data-vt-free-size]');
    if (pill && !pill.classList.contains('is-sold')) {
      e.preventDefault();
      qa('[data-vt-free-size]', picker).forEach(function (x) { x.classList.toggle('is-selected', x === pill); });
      renderFree(picker);
      return;
    }
    if (t.closest('[data-vt-free-add]')) { e.preventDefault(); addFreePair(picker); }
  });

  /* Send the customer back to the thing they still have to do. */
  function nudgeToPicker() {
    var picker = q('[data-vt-free-picker]');
    var warn = q('[data-vt-free-warn]');
    if (picker) picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (warn) {
      /* restart the animation: removing the class and reading offsetWidth forces
         a reflow, otherwise a second blocked click re-adds a class that is
         already there and nothing moves. */
      warn.classList.remove('is-nudged');
      void warn.offsetWidth;
      warn.classList.add('is-nudged');
    }
  }

  /* The checkout button carries the real `disabled` attribute while a free pair
     is unclaimed, so the browser itself refuses the press — nothing here can let
     it through. The two handlers below only cover what `disabled` leaves silent:
       - the guard wrapper receives the click the dead button cannot, so the
         customer gets an explanation instead of nothing happening;
       - `submit` catches a keyboard Enter from the discount field, which would
         otherwise post the form without ever touching the button.
     Both are delegated at the document because the drawer's markup is thrown
     away and re-rendered after every cart change. */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-vt-checkout-guard]')) { e.preventDefault(); nudgeToPicker(); }

    /* Reveal the discount field. The line and the field swap places rather than
       the line staying put, so the footer gains one row instead of two. */
    var discToggle = e.target.closest('[data-vt-discount-toggle]');
    if (discToggle) {
      e.preventDefault();
      var disc = document.getElementById(discToggle.getAttribute('aria-controls'));
      if (disc) {
        disc.hidden = false;
        discToggle.hidden = true;
        discToggle.setAttribute('aria-expanded', 'true');
        var input = disc.querySelector('[data-vt-discount-input]');
        if (input) input.focus();
      }
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('.vh-foot');
    if (!form || !form.querySelector('[data-vt-checkout-blocked]')) return;
    e.preventDefault();
    nudgeToPicker();
  });

  /* the picker is re-rendered with the drawer, so prime it after every refresh */
  function primeFree() { qa('[data-vt-free-picker]').forEach(renderFree); }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeDrawer(); closeMenu(); }
  });

  /* the PDP tells us when something was added */
  document.addEventListener('vantley:cart:added', function () { refresh(true).then(openDrawer); });

  /* keep the count honest if another script changes the cart */
  document.addEventListener('cart:refresh', function () { refresh(false); });
  document.addEventListener('shopify:section:load', primeFree);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', primeFree);
  else primeFree();
})();
